module.exports = __webpack_public_path__ + "static/sql-database-9fd071354498fea83804c93f72ab629d.svg";